module.exports = __webpack_public_path__ + "static/media/instagram.f939292a.png";


//////////////////
// WEBPACK FOOTER
// ./public/instagram.png
// module id = 608
// module chunks = 0